import { DefaultButton, Modal, ProgressIndicator } from "@fluentui/react";
import axios from "axios";
import { Component } from "react";
import PageOverlay from "../helpers/page-overlay";
import PageHeader from "../helpers/page-header";
import IntlUtil from "../../../core/helpers/intl-util";
import moment from "moment";

class UserConsent extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_suc_common = "suc_common";

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }
  async componentDidMount() {
    this._isMounted = true;
    await this.loadPageData();
  }
  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };
  loadPageData = async () => {
   
    await this.setStateAsync({
      consentRecord: this.props.userConsentRecord,
    });
  };
  renderConsentModal = () => {
    return (
      <>
       <Modal
  isOpen={this.props.isUserConsentModalOpen}

  className="order-user-consent-modal"
  layerProps={{ eventBubblingEnabled: true }}
>
  <div className={"modal-wrapper"}>
    {/* Sticky Header */}
    <div className="modal-header-wrapper">
      <div className="modal-header-text">
        {this.state.consentRecord?.consentTitle}
      </div>
      <PageOverlay hidden={!this.props.isConsentSubmitted} />
      
      
    </div>
    {!this.props.isConsentSubmitted && (
        <div className="modal-frame-separator"></div>
      )}
    <ProgressIndicator
        progressHidden={!this.props.isConsentSubmitted}

        className="modal-header-frame-progress-indicator"
      />
    {/* Scrollable Content */}
    <div className={"modal-content"}>
      <div className="m-l-5">
        {this.props.type==="withdraw"?
        <div
        className="m-t-20"
        >
          <span>{IntlUtil.getText(this._intl_ns_suc_common,"notification.info.withdrawConsent")} <span >{moment(this.props.userConsentRecord?.acceptTimestamp).format("MMM DD, YYYY")}</span> at <span >{moment(this.props.userConsentRecord?.acceptTimestamp).format("HH:mm:ss")}.</span></span>
        </div>:<div
        dangerouslySetInnerHTML={{
          __html: this.state.consentRecord?.consentInformation,
        }}
      />}
        
      </div>
    </div>

    {/* Sticky Footer */}
    <div className="modal-footer-wrapper">
    
      <div className="modal-form-actions">
        <DefaultButton
           primary={this.props.type!=="withdraw"}
          text={this.props.type==="withdraw"?IntlUtil.getText(this._intl_ns_suc_common,"content.withdraw"):IntlUtil.getText(this._intl_ns_suc_common,"content.accept")}
          className={this.props.type==="withdraw"?"withdraw-consent-button page-button-primary m-r-10":"page-button-primary m-r-10"}
          onClick={async () => {
            await this.props.handleConsentAccept();
          }}
        />
         <DefaultButton
          text={this.props.type==="withdraw"?IntlUtil.getText(this._intl_ns_suc_common,"content.close"):IntlUtil.getText(this._intl_ns_suc_common,"content.reject")}
          className="page-button-primary m-r-10"
          onClick={async () => {
            await this.props.handleConsentReject();
          }}
        />
      
      </div>
    </div>
  </div>
</Modal>

      </>
    );
  };

  render() {
    return <>
    {this.props.type!=="withdraw"?<div id="spp-page-container">
    <div className="page-header-container">
      <PageHeader
        styleSettings={{ wrapperClassName: "page-main-header-nowrap" }}
        displaySettings={{
          showPageTitle: true,
          showListSearch: false,
          showPageToolbar: true,
        }}
        elementSettings={{
          pageToolbar: {
            feedback: {
              displayStatus: true,
            },
            proxyAccount: {
              displayStatus: false,
              disableStatus: false,
            },
          },
        }}
      />      </div></div>:null}
    {this.renderConsentModal()}</>;
  }
}

export default UserConsent;
